import React from "react";
import { Link } from "@hdir/ui/link";
import CardTitleHeader from "../../CardTitleHeader/CardTitleHeader";

import type { BaseProps } from "../../../../lib/modules/listSearchUtils/index.d";

type BasePropsWithChildrenAndHeaderLevel = BaseProps & {
  children?: React.ReactNode;
  headerLevel?: "h2" | "h3";
}

/**
* Base card for all cards with `CardTitleHeader` as the first props displayed. Card with banners or other UI above the title are custom
*/
export default function Base(props: Readonly<BasePropsWithChildrenAndHeaderLevel>) {
  const {
    children,
    groupBy,
    headerLevel,
    korttittel,
    link,
    title,
    showPdfIcon
  } = props;

  const hasEnoughContent = !!(korttittel || title || link);
  if (!hasEnoughContent) return null;

  return (
    <Link href={link} variant="card" className="min-w-full h-full relative">
      <div className="flex flex-col gap-sm w-full">
        <CardTitleHeader title={title} korttittel={korttittel} groupBy={groupBy} headerLevel={headerLevel} />
        {children}
      </div>
      { showPdfIcon && (
        <span className="absolute right-2 bottom-2 rounded-lg border border-solid border-action-secondary text-action-secondary py-xxs px-md">
          PDF
        </span>
      )}
    </Link>
  );
}
